export default __webpack_public_path__ + "static/media/Icono_rastreo-43.bcee9c7d.svg";